<template>
	<FAQ
		:faqs="props.faq.questions"
		:processed-title="processedTitle"
	/>
</template>
<script setup>
const props = defineProps(["route", "faq"]);

const processedTitle = computed(() => {
	return renderText(props.route);
});

const renderText = (inputText) => {
	const words = inputText
		.replace("/blog", "")
		.split("/")
		.filter((word) => word !== "");

	const processedWords = words.map((word) => {
		return word
			.split("-")
			.map((part) => part.charAt(0).toUpperCase() + part.slice(1))
			.join(" ");
	});

	// Joins the words back into a single string
	let processed = processedWords.join(" ");
	if (processed.includes(":")) {
		processed = processed.replace(":", "");
	}
	if (processed.includes("&#8211;")) {
		processed = processed.replace("&#8211;", "–");
	}
	if (processed.includes("&#038;")) {
		processed = processed.replace("&#038;", "&");
	}
	if (processed.includes("&#8217;")) {
		processed = processed.replace("&#8217;", "'");
	}
	if (processed.includes("&#8230;")) {
		processed = processed.replace("&#8230;", "...");
	}
	if (processed.includes("&#8220;")) {
		processed = processed.replace("&#8220;", "“");
	}
	if (processed.includes("&#8221;")) {
		processed = processed.replace("&#8221;", "”");
	}
	return processed;
};
</script>
